import React from "react";
import styled from "@emotion/styled";
import { TableBody, TableRow, Cell, TableHeader, TableHead } from "@vds/tables";
import { CustomisedTable, CustomSmallText } from "./DocumentFlowTable";

const Container = styled.div`
  ::-webkit-scrollbar {
    display: block !important;
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-thumb {
    display: inline-block !important;
    background-color: #c0c0c0 !important;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
  }
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  color: blue;
  cursor: pointer;
  text-align: left;
  margin-bottom: 5px;
`;

export const MaterialSOInfoTable = ({ data, title, property }) => {
  const openLinkInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  const getDisplayData = (data) => {
    if (data === null || data === undefined) return "--";
    if (typeof data === "string") return data;
    if (typeof data === "number") return data.toString();
    if (Array.isArray(data)) {
      if (data.length > 0 && data[0].carrier) {
        return data.map((item) => item.carrier).join(", ");
      }
      return data.join(", ");
    }
    if (typeof data === "object") {
      if (data.carrier) return data.carrier;
      if (data.id && data.carrier) return data.carrier;
      return JSON.stringify(data);
    }
    return data.toString();
  };

  const displayValue = getDisplayData(data);

  return (
    <>
      <CustomisedTable role="table">
        <TableHead role="row">
          <TableHeader role="columnheader">
            <CustomSmallText bold>{title}</CustomSmallText>
          </TableHeader>
        </TableHead>
        <TableBody role="rowgroup">
          <TableRow role="row">
            <Container css={{ height: "5rem", overflowY: "auto" }}>
              <Cell role="cell" css={{ borderRight: "none !important" }}>
                <CustomSmallText css={{ whiteSpace: "break-spaces" }}>
                  {property === "trackingUrl" && displayValue && displayValue !== "--" ? (
                    <LinkButton role="link" aria-label={`${displayValue}`} onClick={() => openLinkInNewTab(displayValue)}>
                      {displayValue}
                    </LinkButton>
                  ) : (
                    displayValue
                  )}
                </CustomSmallText>
              </Cell>
            </Container>
          </TableRow>
        </TableBody>
      </CustomisedTable>
    </>
  );
};
